export default function formatCompanyName(companyName) {
  const toLowerCaseWords = ['OG', 'og', 'AND', 'and'];
  const toUpperCaseWords = ['AS', 'as'];

  if (companyName) {
    const companyNameArray = companyName.split('-');
    const formattedCompanyName = companyNameArray.map((word) =>
      word.replace(/\w*\S*/g, (txt) => {
        // splitter på space og unngår å splitte på æøå.
        if (toLowerCaseWords.includes(txt)) return txt.toLowerCase();
        if (toUpperCaseWords.includes(txt)) return txt.toUpperCase();

        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      })
    );
    return formattedCompanyName.join('-');
  }
  return companyName;
}
